import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { SidebarModelResponse } from 'src/models/Partner/Sidebar';
import { currentUserSelector } from 'src/store/user/selectors';
import {
  getMenuItems,
  MenuItemProps,
  sideBarCampaignOptionsMainIds,
  sideBarCampaignOptionsOtherQuickLinksIds,
  sideBarCampaignOptionsQuickLinksIds,
} from '../../../helpers/links';

type StaticMenuItemsType = {
  main: MenuItemProps[];
  quickLinks: MenuItemProps[];
  otherQuickLinks: MenuItemProps[];
};

export const useStaticCampaignOptionsMenuItems = (
  allItems: SidebarModelResponse['SelectedCampaignMenuItems'] | undefined
) => {
  const initialState: StaticMenuItemsType = {
    main: [],
    quickLinks: [],
    otherQuickLinks: [],
  };

  const [staticMenuItems, setStaticMenuItems] = useState<StaticMenuItemsType>(initialState);

  const userModel = useSelector(currentUserSelector);

  const organizationId = userModel.response?.organizationInfo.OrganizationUrl || '';

  useEffect(() => {
    if (!allItems) {
      setStaticMenuItems(initialState);
    } else {
      setStaticMenuItems({
        main: getMenuItems(sideBarCampaignOptionsMainIds, allItems, organizationId),
        quickLinks: getMenuItems(sideBarCampaignOptionsQuickLinksIds, allItems, organizationId),
        otherQuickLinks: getMenuItems(sideBarCampaignOptionsOtherQuickLinksIds, allItems, organizationId),
      });
    }
    // eslint-disable-next-line
  }, [allItems, organizationId]);

  return staticMenuItems;
};
